import { Box, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import SingleStepper from 'components/reusable/AdxProgressStepper/SingleStepper'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import { format } from 'date-fns'
import React from 'react'
import { useQuery } from 'react-query'
import { getOneAppliedCourse } from 'services/api/modules/upskill'

const CourseRequestDrawer = ({ drawerState, handleDrawer, data, getStatusText }) => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const id = data?.id

  const { isLoading: courseIsLoading, data: courseData } = useQuery(
    ['courseOneData', id],
    async () => {
      if (drawerState.right && id) {
        const { data } = await getOneAppliedCourse(id)
        return data
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const [requestedLayer, ...remainingLayer] = courseData?.approval_status || []

  const formatDate = (inputDate) => {
    const formattedDate = inputDate ? format(new Date(inputDate), 'EEE, dd/MM/yyyy') : ''
    return formattedDate
  }

  const formatDateNoDay = (inputDate) => {
    const formattedDate = inputDate ? format(new Date(inputDate), 'dd/MM/yyyy, h:mm a') : ''
    return formattedDate
  }

  const CustomHeader = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography>Status</Typography>
      <StatusBar status={getStatusText(data?.status)} sx={{ width: '150px' }} />
    </Box>
  )

  const getNameAndProfileImage = (item) => {
    const { status, waiting_approval_from, approved_by, rejected_by } = item

    switch (status) {
      case 'PendingLayerOne':
        return {
          name: waiting_approval_from?.map((el) => el.name),
          profile_image_url: waiting_approval_from?.map((el) => el.profile_image_url),
        }
      case 'Approved':
        return {
          name: approved_by?.name,
          profile_image_url: approved_by?.profile_image_url,
        }
      case 'Rejected':
        return {
          name: rejected_by?.name,
          profile_image_url: rejected_by?.profile_image_url,
        }
      default:
        return {
          name: null,
          profile_image_url: null,
        }
    }
  }

  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      sx={{ padding: 0 }}
      headerprops={<CustomHeader />}
    >
      <Divider />
      {courseIsLoading ? (
        <Box
          sx={{
            height: '200px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color="alternate" />
        </Box>
      ) : (
        <Box
          sx={{
            padding: '24px',
            height: 'calc(100vh - 92px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', margin: isLarge ? '0 70px' : 0 }}>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}
            >
              {['Requester', 'Type', 'Apply date'].map((text, index) => (
                <Box display="flex" flexDirection={'row'}>
                  <Typography
                    width={110}
                    variant={isLarge ? 'p' : 'body2'}
                    color="light-gray-text.main"
                  >
                    {text}
                  </Typography>
                  <Typography variant={isLarge ? 'p' : 'body2'} color="dark-text.main">
                    {index === 0
                      ? requestedLayer?.requester_name
                      : index === 1
                      ? data?.course_name
                      : index === 2
                      ? formatDate(data?.apply_date)
                      : null}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Typography width={110} variant={isLarge ? 'p' : 'body2'} color="light-gray-text.main">
              Progress
            </Typography>
            <Box sx={{ my: 2.25, minHeight: '20vh' }}>
              <SingleStepper
                active={true}
                activeSubtitle={'Requested'}
                name={'Me'}
                imgUrl={requestedLayer?.requester_image}
                date={formatDateNoDay(requestedLayer?.apply_date)}
              />
              {remainingLayer?.map((item, index) => (
                <SingleStepper
                  key={index}
                  disableLine={true}
                  active={item?.status === 'Approved' ? true : false}
                  isRejected={item?.status === 'Rejected' ? true : false}
                  activeSubtitle={
                    item?.status === 'PendingLayerOne' ? 'Awaiting approval' : item?.status
                  }
                  inactiveSubtitle={
                    item?.status === 'PendingLayerOne' ? 'Awaiting approval' : item?.status
                  }
                  name={getNameAndProfileImage(item)?.name}
                  imgUrl={getNameAndProfileImage(item)?.profile_image_url}
                  date={item?.updated_at ? formatDateNoDay(item?.updated_at) : null}
                />
              ))}
            </Box>
          </Box>
          <AdxButton variant={'outlined'} fullWidth>
            Withdraw
          </AdxButton>
        </Box>
      )}
    </AdxDrawerComponent>
  )
}

export default CourseRequestDrawer
